import { NOT_FOUND } from '@mm/constants/status-codes';
import { Dispatch } from 'redux';
import { unbusyAll } from '../actions/commonActions';
import { UpdateConversationStatusAction } from '../actions/LiveChatCRUDActions';
import modalActions from '../modules/modalsState/actions';
import { StoreState } from '../store-interfaces';
import commonHandler, { ResponseOrError } from './common-handler';

export default (dispatch: Dispatch<StoreState>) =>
  async (error: ResponseOrError, action?: string) => {
    if (
      error instanceof Response &&
      error.status === NOT_FOUND &&
      action === UpdateConversationStatusAction
    ) {
      dispatch(
        modalActions.openPrettyErrorModal({
          title: 'Not found',
          errorMessage: 'Cannot find conversation',
        }),
      );
      dispatch(unbusyAll());
    } else {
      commonHandler(dispatch)(error);
    }
  };
